export default () => ({
	accessToken: null,
	credentials: null,
	hash: null,
	error: null,
});
